export default __webpack_public_path__ + "static/media/security.9e9c0184.md";